import { node, string } from "prop-types"
import { Grid } from "@planningcenter/doxy-web"

CardGrid.propTypes = {
  as: string,
  children: node.isRequired,
}

export default function CardGrid({ as = "section", children }) {
  return (
    <Grid as={as} columns={[1, { sm: 2, lg: 3 }]} gap={[2, { sm: 3, md: 4 }]}>
      {children}
    </Grid>
  )
}
